module.exports = __webpack_public_path__ + "media/images/menu/links-394bf3c4f1165671077b1f24e285809b.jpg";